import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  libraryClassifyTree({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/libraryClassifyTree`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  libraryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/libraryList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveLibraryClassify({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/saveLibraryClassify`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteLibraryClassify({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/deleteLibraryClassify`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/saveLibrary`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  libraryDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/libraryDetail`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`library/deleteLibrary`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
